import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Navbar from  './components/Navbar'
import NavbarRedesign from './components/NavbarRedesign'
import FooterRedesign from './components/FooterRedesign'
import HomePage from './components/HomePage'; 
import SearchPage from './components/SearchPage';
import SignUpPage from './components/SignUpPage';
import Confirmed from './components/Confirmed';
import Confirmed2 from './components/Confirmed2';
import ContactPage2 from './components/ContactPage2';
import Locations from './components/Locations'; 
import Calendar from './components/Calendar'; 
import Connect from './components/Connect'; 
import Connect2 from './components/Connect2'; 
import Connect3 from './components/Connect3'; 
import Privacy from './components/Privacy'; 
import BlogPage from './components/Blog/BlogPage';
import BlogPost from './components/Blog/BlogPost';
import NotFound from './components/NotFound';
import BookingPreference from './components/BookingPreference';
import LocationSelection from './components/LocationSelection';
import AppointmentAvailability from './components/AppointmentAvailability';
import ConnectLogin from './components/ConnectLogin';
import Confirmation from './components/Confirmation';
import SpecificDates from './components/SpecificDates';
import HomeRedesign from './components/HomeRedesign';
import Eligibility from './components/Eligibility';
import Payment from './components/Payment';


const redesignRoutes = ['/', '/eligibility', '/get-started', '/autobook', '/calendar', '/calendar-specific', '/connect', '/payment', '/connect2', '/connect3', '/confirmed2', '/blog', '/contact', '/notify', '/confirmed'];

function AppNav() {
  const location = useLocation();
  const isRedesign = redesignRoutes.includes(location.pathname) || location.pathname.startsWith('/blog/');
  return isRedesign ? <NavbarRedesign /> : <Navbar />;
}

function AppFooter() {
  const location = useLocation();
  const isRedesign = redesignRoutes.includes(location.pathname) || location.pathname.startsWith('/blog/');
  return isRedesign ? <FooterRedesign /> : null;
}

function App() {
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Easy Global Entry"
        defaultTitle="Easy Global Entry - Fast Appointments & Autobooking"
      >
        <meta name="description" content="Secure your Global Entry interview fast with real-time alerts and automatic booking. We help you find appointments at top enrollment centers." />
      </Helmet>
    <div className="App">
      <Router>
        {/* <Header /> */}
        <AppNav />
        <Routes>  
          <Route path="/" element={<HomeRedesign />} />
          <Route path="/eligibility" element={<Eligibility />} />
          <Route path="/get-started" element={<BookingPreference />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/contact" element={<ContactPage2 />} />
          <Route path="/notify" element={<SignUpPage />} />
          <Route path="/confirmed" element={<Confirmed />} />
          <Route path="/confirmed2" element={<Confirmation />} />
          <Route path="/autobook" element={<LocationSelection />} />
          <Route path="/calendar" element={<AppointmentAvailability />} />
          <Route path="/calendar-specific" element={<SpecificDates />} />
          <Route path="/connect" element={<ConnectLogin />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/connect2" element={<Connect2 />} />
          <Route path="/connect3" element={<Connect3 />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <AppFooter />
      </Router>
    </div> 
    </HelmetProvider>
  );  
}

export default App;
